module.exports = __webpack_public_path__ + "static/media/The Wild West.09556a02.jpg";